<template>
  <div>
    <!-- Card Fechamento-->
    <CardFechamento 
      :class="propComponentePai === 'FechamentoFrenteDeCaixa' 
        ? 'w-50 mr-5' : ''" />

    <!-- Card Formas de Pagamento -->
    <CardFormasDePagamento
      :class="propComponentePai === 'FechamentoFrenteDeCaixa' 
        ? 'w-50 mr-5' : ''" />
    
    <!-- Card Tipo de Pagamento -->
    <CardTipoDePagamento
      :class="propComponentePai === 'FechamentoFrenteDeCaixa' 
        ? 'w-50 ' : ''" /> 
  </div>
</template>

<script>
  // Components
  import CardFechamento from "./CardFechamento"
  import CardFormasDePagamento from "./CardFormasDePagamento"
  import CardTipoDePagamento from "./CardTipoDePagamento"


  export default {
    name: "Cards",
    components: {
      CardFechamento,
      CardFormasDePagamento,
      CardTipoDePagamento
    },
    props: {
      propComponentePai: { type: String, default: null },
    },
    data () {
      return {
        pedidos: null,
        formaPg: null,
        tipoPg: null,
        pagamentosAvulso: null,
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2, 
          masked: false
        },
      }
    },
  }
</script>

<style scoped>

</style>